<template>
    <div>

        <stripe-checkout
            ref="checkoutRef"
            mode="payment"
            :pk="publishableKey"
            :sessionId="sessionId"

        />
        <!-- <button @click="submit">Pay now!</button> -->
    </div>
</template>

<script>
    //  :line-items="lineItems"
    //         :success-url="successURL"
    //         :cancel-url="cancelURL"
    //         @loading="(v) => (loading = v)"
import { StripeCheckout } from '@vue-stripe/vue-stripe';
import Axios from 'axios';
export default {
  components: {
    StripeCheckout,
  },
  props: ['orderId','route'],
  data () {
    this.publishableKey = process.env.MIX_STRIPE_KEY;
    return {
      loading: false,
      sessionId: null,
    //   lineItems: [
    //     {
    //         price_data: {
    //             currency: 'eur',
    //             unit_amount: 100,
    //             product_data: {
    //                 name: 'roastopus checkout'
    //             }
    //         },
    //         quantity: 1
    //     }

    //   ],
      successURL: '/your-success-url',
      cancelURL: '/your-cancel-url',
    };
  },
  mounted() {
    this.getSession();

  },
  methods: {
    getSession() {
        console.log(this.route + '/' + this.orderId);
        Axios.get(this.route + '/' + this.orderId)
        .then(res => {
            this.sessionId = res.data.id;
            this.submit();
        })
        .catch(err => {

        });

    },
    submit () {
      // You will be redirected to Stripe's secure checkout page
      this.$refs.checkoutRef.redirectToCheckout();
    },
  },
};
</script>
